import 'izitoast/dist/css/iziToast.css';
import ToastMessage from "./js/ToastMessage";
export default ToastMessage;
